import { getDraggableValueContainerStyles } from 'client/js/common/components/core/PureQueryBuilder/DraggableCompareBy/styles';
import type { DragUpdate } from 'react-beautiful-dnd';
import type { IndexedOption, ValueContainerProps } from 'client/libraries/branch-neo-next/OrderedSelectDropdown/types';

const BASE_WIDTH = 66;
const LETTER_WIDTH = 6;

export const useDroppableValueContainerService = ({
  setValue,
  getValue,
  selectProps,
}: ValueContainerProps<IndexedOption>) => {
  const calculateWidth = () => {
    return selectProps.value.reduce((acc, curr) => {
      const currentWidth = BASE_WIDTH + curr.label.length * LETTER_WIDTH;
      return acc + currentWidth;
    }, 0);
  };

  const reorder = (list: IndexedOption[], startIndex: number, endIndex: number) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onDragEnd = (result: DragUpdate) => {
    if (!result.destination) {
      return;
    }

    const updatedSelection = reorder(getValue(), result.source.index, result.destination.index);
    setValue(updatedSelection, 'reorder');
  };

  const width = calculateWidth();
  const ignoreWidth = width / window.innerWidth > 0.65;
  const css = getDraggableValueContainerStyles(width, ignoreWidth);

  return {
    css,
    onDragEnd,
  };
};
